// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2KL0c","rootCenter":"LoadMoreObserver_rootCenter__ko9-j","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__fdBGo"};